<template>
    <div class="col-md-12">
        <QuickMessagesTable ref="quickMessagesTable"></QuickMessagesTable>
    </div>
</template>

<script>
import QuickMessagesTable from './QuickMessagesTable.vue';

export default {
    name: "ConfigQuickMessages",
    components: {
        QuickMessagesTable,
    },
    data() {
        return {}
    },
}
</script>